export const CJLogo = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='170'
    height='32'
    viewBox='0 0 170 32'
    fill='none'
  >
    <g clipPath='url(#clip0_111_8381)'>
      <path
        d='M51.6829 6.18768C55.2808 6.18768 57.1219 8.15979 57.1219 8.15979L56.084 9.73084C56.084 9.73084 54.3482 8.09647 51.7671 8.09647C48.4219 8.09647 46.2438 10.6415 46.2438 13.8258C46.2438 17.0282 48.467 19.7452 51.7882 19.7452C54.6039 19.7452 56.4029 17.7942 56.4029 17.7942L57.525 19.3019C57.525 19.3019 55.4734 21.6781 51.725 21.6781C47.2366 21.6781 44.0839 18.2405 44.0839 13.85C44.0839 9.49865 47.3419 6.18768 51.6829 6.18768Z'
        fill='#015F94'
      />
      <path
        d='M65.7016 14.7154H66.1679V14.5254C66.1679 12.7644 65.1722 12.1703 63.8184 12.1703C62.1668 12.1703 60.8342 13.2107 60.8342 13.2107L59.9888 11.7029C59.9888 11.7029 61.5351 10.4304 63.9899 10.4304C66.7004 10.4304 68.2226 11.917 68.2226 14.6309V21.4217H66.3183V20.4025C66.3183 19.914 66.3604 19.5552 66.3604 19.5552H66.3183C66.3183 19.5552 65.4519 21.6781 62.8888 21.6781C61.0478 21.6781 59.2488 20.5533 59.2488 18.4093C59.2458 14.8662 63.9026 14.7154 65.7016 14.7154ZM63.3311 20.0196C65.0669 20.0196 66.189 18.1952 66.189 16.6031V16.2653H65.6595C64.1132 16.2653 61.3215 16.3709 61.3215 18.3008C61.3185 19.1722 61.9954 20.0196 63.3311 20.0196Z'
        fill='#015F94'
      />
      <path
        d='M71.3483 10.6867H73.3368V12.5533C73.3368 12.9996 73.2946 13.3584 73.2946 13.3584H73.3368C73.8241 11.7874 75.0726 10.5571 76.7241 10.5571C76.9979 10.5571 77.2536 10.5993 77.2536 10.5993V12.6347C77.2536 12.6347 76.9798 12.5714 76.661 12.5714C75.3493 12.5714 74.143 13.5062 73.6556 15.0953C73.4661 15.7105 73.4029 16.3678 73.4029 17.0252V21.4157H71.3513V10.6867H71.3483Z'
        fill='#015F94'
      />
      <path
        d='M83.7756 10.4304C86.802 10.4304 88.4114 12.6799 88.4114 15.4602C88.4114 15.7346 88.3482 16.3528 88.3482 16.3528H80.5386C80.6439 18.7078 82.3166 19.8959 84.2208 19.8959C86.0619 19.8959 87.3946 18.6445 87.3946 18.6445L88.2399 20.1522C88.2399 20.1522 86.6515 21.6811 84.0915 21.6811C80.7252 21.6811 78.4178 19.2416 78.4178 16.0573C78.4208 12.6377 80.7282 10.4304 83.7756 10.4304ZM86.3146 14.7998C86.2514 12.9544 85.1083 12.0618 83.7335 12.0618C82.1661 12.0618 80.8966 13.0388 80.6018 14.7998H86.3146Z'
        fill='#015F94'
      />
      <path
        d='M90.084 16.3709H92.1598V17.0071C92.1598 19.0426 93.3451 19.7452 94.5303 19.7452C95.6946 19.7452 96.8588 19.0667 96.8588 17.0946V8.26533H93.0924V6.44098H98.9556V17.1127C98.9556 20.3603 96.6903 21.6751 94.5093 21.6751C92.3282 21.6751 90.084 20.3392 90.084 17.1127V16.3709Z'
        fill='#015F94'
      />
      <path
        d='M107.388 10.4304C110.583 10.4304 113.167 12.7855 113.167 16.0301C113.167 19.2989 110.586 21.675 107.388 21.675C104.19 21.675 101.609 19.2989 101.609 16.0331C101.609 12.7855 104.193 10.4304 107.388 10.4304ZM107.388 19.8929C109.418 19.8929 111.07 18.2796 111.07 16.0301C111.07 13.8017 109.418 12.2126 107.388 12.2126C105.378 12.2126 103.706 13.8047 103.706 16.0301C103.706 18.2796 105.378 19.8929 107.388 19.8929Z'
        fill='#015F94'
      />
      <path
        d='M115.57 10.6868H117.625V17.0946C117.625 18.5812 117.92 19.7693 119.635 19.7693C121.816 19.7693 123.106 17.8394 123.106 15.7165V10.6868H125.158V21.4218H123.17V20.0015C123.17 19.5552 123.212 19.2175 123.212 19.2175H123.17C122.724 20.2789 121.328 21.6781 119.232 21.6781C116.819 21.6781 115.57 20.4056 115.57 17.562V10.6868Z'
        fill='#015F94'
      />
      <path
        d='M128.347 10.6867H130.335V12.5533C130.335 12.9996 130.293 13.3584 130.293 13.3584H130.335C130.823 11.7874 132.071 10.5571 133.723 10.5571C133.999 10.5571 134.252 10.5993 134.252 10.5993V12.6347C134.252 12.6347 133.975 12.5714 133.66 12.5714C132.348 12.5714 131.142 13.5062 130.654 15.0953C130.465 15.7105 130.402 16.3678 130.402 17.0252V21.4157H128.35V10.6867H128.347Z'
        fill='#015F94'
      />
      <path
        d='M136.343 10.6867H138.331V12.107C138.331 12.5322 138.289 12.891 138.289 12.891H138.331C138.756 11.9562 140.025 10.4304 142.354 10.4304C144.872 10.4304 146.036 11.8085 146.036 14.5465V21.4218H143.981V15.0139C143.981 13.5062 143.665 12.3181 141.95 12.3181C140.32 12.3181 139.008 13.4006 138.563 14.9476C138.437 15.3727 138.395 15.8613 138.395 16.392V21.4187H136.343V10.6867Z'
        fill='#015F94'
      />
      <path
        d='M153.719 10.4304C156.745 10.4304 158.355 12.6799 158.355 15.4602C158.355 15.7346 158.292 16.3528 158.292 16.3528H150.482C150.587 18.7078 152.26 19.8959 154.164 19.8959C156.005 19.8959 157.338 18.6445 157.338 18.6445L158.183 20.1522C158.183 20.1522 156.595 21.6811 154.035 21.6811C150.669 21.6811 148.361 19.2416 148.361 16.0573C148.364 12.6377 150.672 10.4304 153.719 10.4304ZM156.258 14.7998C156.195 12.9544 155.052 12.0618 153.677 12.0618C152.11 12.0618 150.84 13.0388 150.545 14.7998H156.258Z'
        fill='#015F94'
      />
      <path
        d='M160.157 23.6472C160.157 23.6472 160.749 24.0934 161.405 24.0934C162.229 24.0934 162.93 23.4994 163.331 22.5224L163.86 21.2921L159.372 10.6837H161.679L164.368 17.7067C164.579 18.2585 164.771 19.0003 164.771 19.0003H164.814C164.814 19.0003 164.982 18.2796 165.175 17.7278L167.777 10.6837H170L164.985 23.3486C164.329 25.0041 163.018 25.8726 161.514 25.8726C160.307 25.8726 159.438 25.2152 159.438 25.2152L160.157 23.6472Z'
        fill='#015F94'
      />
      <path
        d='M6.18811 5.72635L11.4557 7.78289L21.5997 3.90803L32.0446 7.75273L37.3091 5.7565L21.4222 0L6.18811 5.72635Z'
        fill='#3992C6'
      />
      <path
        d='M4.75916 6.5918V10.6174L21.5395 16.9408L38.7682 10.5571L38.6479 6.62195L21.6599 12.885L4.75916 6.5918Z'
        fill='#009FD3'
      />
      <path
        d='M0 14.1365V18.1621L16.7804 24.4855L34.006 18.1018L33.8887 14.1666L16.9007 20.4297L0 14.1365Z'
        fill='#EC9F24'
      />
      <path
        d='M4.87946 21.651V25.6766L21.6598 32L38.8855 25.6193L38.7682 21.6812L21.7802 27.9443L4.87946 21.651Z'
        fill='#015F94'
      />
      <path
        d='M1.35376 13.2409L4.83438 11.9894L10.0418 14.046L6.6484 15.4029L1.35376 13.2409Z'
        fill='#EC9F24'
      />
      <path
        d='M37.264 20.882L33.7834 19.6276L28.576 21.6871L31.9694 23.0441L37.264 20.882Z'
        fill='#005980'
      />
    </g>
    <defs>
      <clipPath id='clip0_111_8381'>
        <rect width='170' height='32' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const ChatCJLogo = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='42'
    height='42'
    viewBox='0 0 42 42'
    fill='none'
  >
    <path
      d='M0.190903 23.6727L18.1408 30.3056C18.2263 30.3372 18.3201 30.3372 18.4055 30.3056L36.3555 23.6727V26.6842C36.3555 27.4542 36.6141 28.2019 37.0898 28.8073L41.1022 33.9136C41.3266 34.1992 41.0631 34.6072 40.7105 34.5202L28.339 31.4665C27.6713 31.3017 26.9695 31.3411 26.3244 31.5794L18.4055 34.5056C18.3201 34.5372 18.2263 34.5372 18.1408 34.5056L0.190903 27.8727V23.6727Z'
      fill='#015F94'
    />
    <path
      d='M0.190903 18.9L18.2732 25.5818L36.3555 18.9V23.1L18.2732 29.7818L0.190903 23.1V18.9Z'
      fill='#EC9F24'
    />
    <path
      d='M0.190903 14.1273L18.2732 20.8091L36.3555 14.1273V18.3273L18.2732 25.0091L0.190903 18.3273V14.1273Z'
      fill='#009FD3'
    />
    <path
      d='M29.6392 15.6545L18.2732 11.4545L6.90719 15.6545L1.22418 13.5545L18.2732 7.25455L35.3222 13.5545L29.6392 15.6545Z'
      fill='#3992C6'
    />
  </svg>
);
